module.exports = __webpack_public_path__ + "static/media/icon-character__francois-mitterrand.7bd16e91.svg";